export let blogs = [

   {
     image:
       "https://plus.unsplash.com/premium_photo-1683842188982-e2920f594fda?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
     title: "How to Verify Your Sprinterwave Account for Full Access",
     page: "How_to_Verify_Your_Sprinterwave_Account_for_Full_Access",
     date: "May 12, 2026",
     readTime: 1

   },
   
   {
      id:1,
     image:
       "https://img.freepik.com/free-photo/delete-cancel-cut-out-remove-erase-edit_53876-132168.jpg?t=st=1743947706~exp=1743951306~hmac=1ab401acff4159ba6cb2a8a0deb5d40bfd173fd4dab727a387707b40c36e6b7d&w=2000",
     title: "How to Close Your Sprinterwave Account",
     page: "How_to_Close_Your_Sprinterwave_Account",
     date: "April 5, 2025",
     readTime: 1
   },

  
 ];